import CloseIcon from '@mui/icons-material/Close';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { Box, Stack, Tab, Tabs, useTheme } from '@mui/material';
import { useState } from 'react';
import { formatLossGainValue, numberWithPoint } from '../../../utils/utils';
import { ButtonsPrimary, ButtonsSecondary, ButtonsTertiary } from '../../ComponentApp/buttoms';
import Spinner from '../../Spinner';
import ChartComponentInvestmentContainer from '../../XcalaComponents/ChartComponentInvestmentContainer';
import {
  BtnContainer,
  BtnGroupContainer,
  BtnGroupPortfolio,
  ChartWrapperPortfolio,
  CondicionesGenerales,
  ContentTitleTable,
  DistributionValue,
  Divaider,
  GeneralConditionBody,
  GeneralConditionCard,
  GeneralConditionFooter,
  GeneralConditionHead,
  HeadContainer,
  HeadTitleDistribution,
  HeadTitleDistributionSpan,
  InvestmentActionContainer,
  ItemContentDescription,
  ItemDescription,
  SectionDistribucion,
  SectionGeneralCondit,
  TitleItemContent,
  TitleItemFooter,
  TitleTableName,
  ValueItemContent,
  ValueItemFooter,
} from './PortfolioInvestmentComponents';
import { TabletInverted } from './TabletInverted';

const BodyInvertedPortfolio = ({
  idSelected,
  fileAs,
  ModelId,
  visible,
  handleOpen,
  handleClose,
  handleInvestMore,
  handleRescueInvestment,
  simulation = ' Rescatar Inversión',
  investmentMore = ' Invertir Más',
  statusDividendFinfolio,
  successGetPortfolioById,
  loadingGetSecurityPriceRangePortfolio,
  loadingPortfolioTransaction,
  successGetPortfolioTransaction,
  successGetSecurityPriceRangePortfolio,
  doGetSecurityPriceRangePortfolio,
  dataGetSecurityPriceRangePortfolio,
}) => {
  const theme = useTheme();

  const colores = {
    'HMC Bitcoin': theme.palette.customColors.hmcBitcoin,
    'HMC Portafolio Óptimo': theme.palette.customColors.hmcPortafolioOptimo,
    'HMC Deuda Privada Global': theme.palette.customColors.hmcDeudaPrivadaGlobal,
    'HMC Global Real Estate Income': theme.palette.customColors.hmcGlobalRealEstateIncome,
    'HMC US Venture Opportunities': theme.palette.customColors.hmcUSVentureOpportunities,
    'HMC Rendimiento Estratégico Dólar': theme.palette.customColors.hmcRendimientoEstrategicoDolar,
    'HMC Renta Global USD': theme.palette.customColors.hmcRentaGlobalUSD,
    Caja: theme.palette.primary.main,
  };

  const [value, setValue] = useState(0);

  const summaryDetails = successGetPortfolioById.find(
    porfolio => porfolio.id === '' && porfolio.name === '' && porfolio.security === '',
  );

  const distributioInvestmentProducts = successGetPortfolioById.filter(porfolio =>
    porfolio.security.includes('HMC'),
  );
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  if (loadingPortfolioTransaction) {
    return <Spinner />;
  }
  const completedTransactions = successGetPortfolioTransaction
    .filter(item => item.Status === 4 && item.SubType !== 'LO' && item.SubType !== 'LI')
    .sort((a, b) => new Date(b.tradeDate) - new Date(a.tradeDate));

  const pendingTransactions = successGetPortfolioTransaction
    .filter(
      item =>
        item.Status === 2 || (item.Status === 1 && item.SubType !== 'LO' && item.SubType !== 'LI'),
    )
    .sort((a, b) => new Date(b.tradeDate) - new Date(a.tradeDate));

  return (
    <Stack
      sx={{
        width: '90%',
        marginTop: '48px',
        borderRadius: '16px',
        position: 'relative',
        marginX: 'auto',
        isolation: 'isolate',
        marginBottom: '4rem',
      }}
      gap={4}>
      <Stack sx={{ width: '100%' }} gap={2} flexDirection={{ md: 'row', xs: 'column' }}>
        <ChartWrapperPortfolio>
          <ChartComponentInvestmentContainer
            doGetSecurityPriceRangePortfolio={doGetSecurityPriceRangePortfolio}
            loadingGetSecurityPriceRangePortfolio={loadingGetSecurityPriceRangePortfolio}
            successGetSecurityPriceRangePortfolio={successGetSecurityPriceRangePortfolio}
            dataGetSecurityPriceRangePortfolio={dataGetSecurityPriceRangePortfolio}
          />
        </ChartWrapperPortfolio>

        <InvestmentActionContainer>
          <BtnGroupContainer direction={'column'}>
            <BtnGroupPortfolio>
              <BtnContainer flexDirection={{ md: 'row', xs: 'column' }} gap={2}>
                <ButtonsSecondary
                  name={simulation}
                  onClick={() => handleRescueInvestment(idSelected)}
                  fullWidth
                  sx={{ whiteSpace: 'nowrap' }}
                />
                <ButtonsPrimary
                  name={investmentMore}
                  onClick={() => handleInvestMore(ModelId)}
                  fullWidth
                />
              </BtnContainer>
              {statusDividendFinfolio && (
                <Stack
                  width={'100%'}
                  sx={{
                    paddingTop: '0px',
                    paddingLeft: '16px',
                    paddingRight: '16px',
                    paddingBottom: '16px',
                  }}>
                  {fileAs.products === true &&
                    (!visible && statusDividendFinfolio.length > 0 ? (
                      <ButtonsTertiary
                        name='Reinvertir Dividendos'
                        endIcon={<KeyboardArrowRightIcon />}
                        fullWidth
                        onClick={handleOpen}
                        imgUrl='/assets/images/edit.svg'
                        sx={{ whiteSpace: 'nowrap' }}
                      />
                    ) : statusDividendFinfolio.length > 0 ? (
                      <ButtonsTertiary
                        name='Cancelar'
                        startIcon={<CloseIcon />}
                        endIcon={<KeyboardArrowDownIcon />}
                        fullWidth
                        onClick={handleClose}
                      />
                    ) : null)}
                </Stack>
              )}
            </BtnGroupPortfolio>
          </BtnGroupContainer>
          <SectionGeneralCondit marginTop='16px'>
            <GeneralConditionCard>
              <GeneralConditionHead>
                <CondicionesGenerales>Condiciones Generales</CondicionesGenerales>
              </GeneralConditionHead>

              <GeneralConditionBody>
                <ItemContentDescription>
                  <TitleItemContent>Tienes</TitleItemContent>
                  <ValueItemContent>
                    $ {numberWithPoint(Math.round(Number.parseFloat(summaryDetails.marketValue)))}
                  </ValueItemContent>
                </ItemContentDescription>
                <ItemContentDescription>
                  <TitleItemContent>Dividendos</TitleItemContent>
                  <ValueItemContent>
                    $ {numberWithPoint(Math.round(summaryDetails.dividends))}
                  </ValueItemContent>
                </ItemContentDescription>
                <ItemContentDescription>
                  <TitleItemContent>Rescates</TitleItemContent>
                  <ValueItemContent>
                    {summaryDetails.sell === 0
                      ? '$ 0'
                      : `- $ ${numberWithPoint(Math.abs(Math.round(summaryDetails.sell)))}`}
                  </ValueItemContent>
                </ItemContentDescription>
                <Divaider />
                <ItemContentDescription>
                  <TitleItemContent>Total Depositado</TitleItemContent>
                  <ValueItemContent>
                    $ {numberWithPoint(Math.round(summaryDetails.buy))}
                  </ValueItemContent>
                </ItemContentDescription>
                <ItemContentDescription>
                  <TitleItemContent>Comisión de salida:</TitleItemContent>
                  <ValueItemContent>Según reglamento fondos</ValueItemContent>
                </ItemContentDescription>
                <ItemContentDescription>
                  <TitleItemContent>Plazo de rescate:</TitleItemContent>
                  <ValueItemContent>Según reglamento fondos</ValueItemContent>
                </ItemContentDescription>
              </GeneralConditionBody>

              <GeneralConditionFooter>
                <ItemContentDescription>
                  <TitleItemFooter>Ganancia / Pérdida:</TitleItemFooter>
                  <ValueItemFooter>
                    {formatLossGainValue(summaryDetails.capitalAppreciation)}
                  </ValueItemFooter>
                </ItemContentDescription>
              </GeneralConditionFooter>
            </GeneralConditionCard>
          </SectionGeneralCondit>
        </InvestmentActionContainer>
      </Stack>

      {/*Distribución de % de fondos Portafolio  */}
      <Stack
        sx={{
          width: '100%',
          overflow: 'hidden',
          borderRadius: '8px',
        }}>
        <DistributionValue>
          <HeadContainer sx={{ maxWidth: { xs: '300px', md: '370px' } }}>
            <HeadTitleDistribution>
              Distribución de tus{' '}
              <HeadTitleDistributionSpan variant='span'>inversiones</HeadTitleDistributionSpan>
            </HeadTitleDistribution>
          </HeadContainer>
          <SectionDistribucion>
            {distributioInvestmentProducts.map(product => {
              return <ItemDescription key={product.id} product={product} colores={colores} />;
            })}
          </SectionDistribucion>
        </DistributionValue>
      </Stack>

      <Stack
        sx={{
          backgroundColor: theme.palette.white.main,
          boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
          borderTop: '1px solid rgba(170, 167, 167, 0.25)',
          borderRadius: '8px',
          display: 'flex',
          position: 'relative',
          isolation: 'isolate',
          flexDirection: 'column',
          justifyContent: 'flex-start',
          alignItems: 'flex-start',
          padding: '32px',
        }}>
        <ContentTitleTable>
          <TitleTableName variant='h2'>Cartola de movimientos</TitleTableName>
        </ContentTitleTable>
        <Box sx={{ width: '100%', my: 2 }}>
          <Tabs
            onChange={handleChange}
            value={value}
            aria-label='Tabs where selection follows focus'
            selectionFollowsFocus>
            <Tab sx={{ flex: '1 1 auto', textTransform: 'uppercase' }} label='Realizados' />
            <Tab sx={{ flex: '1 1 auto', textTransform: 'uppercase' }} label='Pendientes' />
          </Tabs>
        </Box>
        {value === 0 && <TabletInverted transactions={completedTransactions} colores={colores} />}

        {value === 1 && <TabletInverted transactions={pendingTransactions} colores={colores} />}
      </Stack>
    </Stack>
  );
};

export default BodyInvertedPortfolio;
